export const enum Theme {
  Light = "light",
  Dark = "dark",
}
